import { render, staticRenderFns } from "./product_detail.vue?vue&type=template&id=c518725a&scoped=true&"
import script from "./product_detail.vue?vue&type=script&lang=js&"
export * from "./product_detail.vue?vue&type=script&lang=js&"
import style0 from "./product_detail.vue?vue&type=style&index=0&id=c518725a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c518725a",
  null
  
)

export default component.exports